<template>
  <div>
    <MessagePopup
      v-if="notificationStore.messagePopupProps['showMessagePopup']"
      :hide-message-popup="
        () => {
          notificationStore.setMessagePopup({ showMessagePopup: false });
        }
      "
      :click-handle="
        () => {
          notificationStore.messagePopupProps['clickHandle']
            ? notificationStore.messagePopupProps['clickHandle']()
            : notificationStore.setMessagePopup({ showMessagePopup: false });
        }
      "
      :message="notificationStore.messagePopupProps['message']"
      :title="notificationStore.messagePopupProps['title']"
      :button-text="buttonText"
    />
  </div>
</template>

<script>
import { mapStores } from 'pinia';
import { defineComponent } from 'vue';

import MessagePopup from '@/components/MessagePopup.vue';
import { useNotificationStore } from '@/stores/notification';

const comp = defineComponent({
  name: 'SharedMessagePopup',
  components: {
    MessagePopup,
  },
  computed: {
    ...mapStores(useNotificationStore),
    buttonText() {
      return this.notificationStore.messagePopupProps.buttonText
        ? this.notificationStore.messagePopupProps.buttonText
        : 'Got it';
    },
  },
});
export default comp;
</script>
